<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0">Cadastrar</h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item fw-semibold">Cadastro</li>
  </ol>
</div>

<mat-card class="mb-25 tagus-card">
  <mat-card-content>
    <mat-stepper #stepper linear class="tagus-wizard">
      <mat-step [stepControl]="professionalForm">
        <ng-template matStepLabel>Dados pessoais</ng-template>
        <form [formGroup]="professionalForm">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Nome completo <span>*</span></label
                >
                <mat-form-field>
                  <i class="ri-user-3-line"></i>
                  <mat-label>Insira o nome</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="fullname"
                    id="fullname"
                    style="text-transform: uppercase"
                  />
                  <mat-error
                    *ngIf="hasErrorProfessional('fullname', 'required')"
                    >O nome é obrigatório</mat-error
                  >
                  <mat-error
                    *ngIf="hasErrorProfessional('fullname', 'minlength')"
                    >O nome deve ter no mínimo 3 caracteres</mat-error
                  >
                  <mat-error
                    *ngIf="hasErrorProfessional('fullname', 'maxlength')"
                    >O nome não deve conter mais do que 255
                    caracteres</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Nome do Pai <span>*</span></label
                >
                <mat-form-field>
                  <i class="ri-user-3-line"></i>
                  <mat-label>Insira o nome</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="fatherName"
                    id="fatherName"
                    style="text-transform: uppercase"
                  />
                  <mat-error
                    *ngIf="hasErrorProfessional('fatherName', 'required')"
                    >O nome do Pai é obrigatório</mat-error
                  >
                  <mat-error
                    *ngIf="hasErrorProfessional('fatherName', 'minlength')"
                    >O nome deve ter no mínimo 3 caracteres</mat-error
                  >
                  <mat-error
                    *ngIf="hasErrorProfessional('fatherName', 'maxlength')"
                    >O nome não deve conter mais do que 255
                    caracteres</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Nome da Mãe<span>*</span></label
                >
                <mat-form-field>
                  <i class="ri-user-3-line"></i>
                  <mat-label>Insira o nome da Mãe</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="motherName"
                    id="motherName"
                    style="text-transform: uppercase"
                  />
                  <mat-error
                    *ngIf="hasErrorProfessional('motherName', 'required')"
                    >O nome da Mãe é obrigatório</mat-error
                  >
                  <mat-error
                    *ngIf="hasErrorProfessional('motherName', 'minlength')"
                    >O nome deve ter no mínimo 3 caracteres</mat-error
                  >
                  <mat-error
                    *ngIf="hasErrorProfessional('motherName', 'maxlength')"
                    >O nome não deve conter mais do que 255
                    caracteres</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >CPF <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-file-text-line"></i>
                  <mat-label>Insira o CPF</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="document"
                    id="document"
                    mask="CPF_CNPJ"
                  />
                  <mat-error
                    *ngIf="hasErrorProfessional('document', 'required')"
                    >O CPF é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >E-mail <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-mail-line"></i>
                  <mat-label>Insira o e-mail</mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="email"
                    id="email"
                    style="text-transform: lowercase"
                  />
                  <mat-error *ngIf="hasErrorProfessional('email', 'required')"
                    >Email é obrigatório</mat-error
                  >
                  <mat-error *ngIf="hasErrorProfessional('email', 'minlength')"
                    >Email deve ter no mínimo 3 caracteres</mat-error
                  >
                  <mat-error *ngIf="hasErrorProfessional('email', 'maxlength')"
                    >Email não deve conter mais do que 80 caracteres</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Função/Cargo <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-list-check"></i>
                  <mat-label>Função/Cargo</mat-label>
                  <mat-select formControlName="type">
                    <mat-option value="DOCTOR">Médico(a)</mat-option>
                    <mat-option value="NURSE">Enfermeiro(a)</mat-option>
                  </mat-select>
                  <mat-error *ngIf="hasErrorProfessional('type', 'required')"
                    >Função/Cargo é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Gênero <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-group-line"></i>
                    <mat-label>Gênero</mat-label>
                    <mat-select formControlName="genre" id="genre">
                      <mat-option value="male">Masculino</mat-option>
                      <mat-option value="female">Feminino</mat-option>
                      <mat-option value="others">Outros</mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasErrorProfessional('genre', 'required')"
                      >Gênero é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Estado Civil <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-list-check"></i>
                    <mat-label>Estado civil</mat-label>
                    <mat-select formControlName="civilStatus">
                      <mat-option value="single">Solteiro(a)</mat-option>
                      <mat-option value="married">Casado(a)</mat-option>
                      <mat-option value="engaged">Noivo(a)</mat-option>
                      <mat-option value="divorced">Divorciado(a)</mat-option>
                      <mat-option value="widowed">Viúvo(a)</mat-option>
                      <mat-option value="common-law-marriage"
                        >União estável</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="hasErrorProfessional('civilStatus', 'required')"
                      >Estado civil é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Data de Nascimento <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-calendar-line"></i>
                    <mat-label>Data de Nascimento</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="birthdate"
                      id="birthdate"
                      mask="00/00/0000"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('birthdate', 'required')"
                      >Data de Nascimento é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Nº Identidade <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-article-line"></i>
                    <mat-label>Insira nº da identidade</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="identity"
                      id="identity"
                      mask="separator"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('identity', 'required')"
                      >Nº da identidade é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Órgão emissor <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-user-4-line"></i>
                    <mat-label>Órgão emissor</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="identityAgency"
                      id="identityAgency"
                      style="text-transform: uppercase"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('identityAgency', 'required')"
                      >Órgão emissor é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Data de emissão <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-calendar-line"></i>
                    <mat-label>Data de emissão</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="identityDate"
                      id="identityDate"
                      mask="00/00/0000"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('identityDate', 'required')"
                      >Data de emissão é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >UF Emissão <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-list-check"></i>
                    <mat-label>UF</mat-label>
                    <mat-select formControlName="identityUf">
                      <mat-option
                        *ngFor="let state of states"
                        [value]="state"
                        >{{ state.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="hasErrorProfessional('identityUf', 'required')"
                      >UF Emissão é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div formGroupName="phone" class="row">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Telefone</label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-phone-line"></i>
                    <mat-label>Insira o número de telefone</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="phone"
                      mask="(00) 0000-0000"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Celular <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-smartphone-line"></i>
                    <mat-label>Insira o número do celular</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="cellphone"
                      mask="+00 (00) 0 0000-0000"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Nacionalidade <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-list-check"></i>
                    <mat-label>Nacionalidade</mat-label>
                    <mat-select formControlName="nationality">
                      <mat-option
                        *ngFor="let nationality of nationalities"
                        [value]="nationality"
                        >{{ nationality }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="hasErrorProfessional('nationality', 'required')"
                      >Nacionalidade é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Naturalidade <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-list-check"></i>
                    <mat-label>Naturalidade</mat-label>
                    <mat-select formControlName="citizenship">
                      <mat-option
                        *ngFor="let state of states"
                        [value]="state"
                        >{{ state.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="hasErrorProfessional('citizenship', 'required')"
                      >Naturalidade é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Cidade de Nascimento <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-map-2-line"></i>
                    <mat-label>Cidade de nascimento</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="birthplace"
                      id="birthplace"
                      style="text-transform: uppercase"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('birthplace', 'required')"
                      >Cidade de nascimento é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Título de eleitor <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-map-2-line"></i>
                    <mat-label>Insira o Título de eleitor</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="voterRegistration"
                      id="voterRegistration"
                    />
                    <mat-error
                      *ngIf="
                        hasErrorProfessional('voterRegistration', 'required')
                      "
                      >Título de eleitor é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Nº do PIS <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-map-2-line"></i>
                    <mat-label>Número do PIS</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="pis"
                      id="pis"
                    />
                    <mat-error *ngIf="hasErrorProfessional('pis', 'required')"
                      >Nº do PIS é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Nº Licença <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-file-list-3-line"></i>
                    <mat-label>Licença (CRM/ENF/Outro)</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="licenseNumber"
                      id="licenseNumber"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('licenseNumber', 'required')"
                      >Nº Licença é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Nº RQE
                  </label>
                  <mat-form-field appearance="fill">
                    <i class="ri-article-fill"></i>
                    <mat-label>Insira o nº do RQE</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="rqe"
                      id="rqe"
                      mask="separator"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Principal especialidade médica <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <mat-label>Especialidade</mat-label>
                    <i class="ri-list-check"></i>
                    <mat-select formControlName="majorMedicalSpecialty">
                      <mat-option
                        *ngFor="let specialty of specialties"
                        [value]="specialty._id"
                        >{{ specialty.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        hasErrorProfessional(
                          'majorMedicalSpecialty',
                          'required'
                        )
                      "
                      >Especialidade principal é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Outras especialidades</label
                  >
                  <mat-form-field appearance="fill">
                    <mat-label>Outras especialidade</mat-label>
                    <i class="ri-list-check"></i>
                    <mat-select formControlName="otherSpecialties">
                      <mat-option
                        *ngFor="let specialty of specialties"
                        [value]="specialty._id"
                        >{{ specialty.name }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Àrea de atuação <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <mat-label>Àrea de atuação</mat-label>
                    <i class="ri-list-check"></i>
                    <mat-select formControlName="occupationArea">
                      <mat-option
                        *ngFor="let area of occupationAreas"
                        [value]="area._id"
                        >{{ area.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="hasErrorProfessional('occupationArea', 'required')"
                      >Área de atuação é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Número do SUS <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-file-list-3-line"></i>
                    <mat-label>Insira o número do SUS</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="numberHealth"
                      id="numberHealth"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('numberHealth', 'required')"
                      >Número do SUS é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Tipo sanguíneo <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-drop-line"></i>
                    <mat-label>Selecione o tipo sanguíneo</mat-label>
                    <mat-select formControlName="bloodType">
                      <mat-option value="A+">A+</mat-option>
                      <mat-option value="A-">A-</mat-option>
                      <mat-option value="B+">B+</mat-option>
                      <mat-option value="B-">B-</mat-option>
                      <mat-option value="AB+">AB+</mat-option>
                      <mat-option value="AB-">AB-</mat-option>
                      <mat-option value="O+">O+</mat-option>
                      <mat-option value="O-">O-</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="hasErrorProfessional('bloodType', 'required')"
                      >Tipo sanguíneo é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Vínculo Trabalhista</label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-briefcase-line"></i>
                    <mat-label>Selecione o vínculo trabalhista</mat-label>
                    <mat-select formControlName="employmentType">
                      <mat-option *ngFor="let opt of employmentTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Senha de Acesso <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-lock-password-fill"></i>
                    <mat-label>Senha de Acesso</mat-label>
                    <input
                      matInput
                      type="password"
                      formControlName="password"
                      id="password"
                    />
                    <mat-error
                      *ngIf="hasErrorProfessional('password', 'required')"
                      >Senha de acesso é obrigatório</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('password', 'minlength')"
                      >A senha deve conter no mínimo 6 caracteres</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-3 fw-semibold gray-color"
                    >Confirmar Senha de Acesso <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-lock-password-fill"></i>
                    <mat-label>Confirmar senha de Acesso</mat-label>
                    <input
                      matInput
                      type="password"
                      formControlName="confirmPassword"
                      id="confirmPassword"
                    />
                    <mat-error
                      *ngIf="
                        hasErrorProfessional('confirmPassword', 'required')
                      "
                      >Confirmar senha de acesso é obrigatório</mat-error
                    >
                    <mat-error
                      *ngIf="
                        hasErrorProfessional('confirmPassword', 'minlength')
                      "
                      >A senha deve conter no mínimo 6 caracteres</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <button
              mat-flat-button
              matStepperNext
              class="tagus"
              [disabled]="!professionalForm.valid"
            >
              Próximo
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="addressForm">
        <ng-template matStepLabel>Dados de Endereço</ng-template>
        <form [formGroup]="addressForm">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >CEP <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-file-code-line"></i>
                  <mat-label>Insira o CEP</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="zipcode"
                    id="zipcode"
                    mask="00000-000"
                  />
                  <mat-error *ngIf="hasErrorAddress('zipcode', 'required')"
                    >O CEP é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Logradouro <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-navigation-line"></i>
                  <mat-label>Insira o logradouro</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="street"
                    id="street"
                    style="text-transform: uppercase;"
                  />
                  <mat-error *ngIf="hasErrorAddress('street', 'required')"
                    >O CEP é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Número <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-home-5-line"></i>
                  <mat-label>Insira o número</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="number"
                    id="number"
                  />
                  <mat-error *ngIf="hasErrorAddress('number', 'required')"
                    >O número é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Bairro <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-community-line"></i>
                  <mat-label>Insira o bairro</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="neighborhood"
                    id="neighborhood"
                    style="text-transform: uppercase;"
                  />
                  <mat-error *ngIf="hasErrorAddress('neighborhood', 'required')"
                    >O bairro é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Complemento</label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-road-map-line"></i>
                  <mat-label>Insira o complemento</mat-label>
                  <input matInput formControlName="complement" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Cidade <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-map-pin-line"></i>
                  <mat-label>Insira a cidade</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="city"
                    id="city"
                    style="text-transform: uppercase;"
                  />
                  <mat-error *ngIf="hasErrorAddress('city', 'required')"
                    >A cidade é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Estado <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-map-2-line"></i>
                  <mat-label>Insira o estado</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="state"
                    id="state"
                    style="text-transform: uppercase;"
                  />
                  <mat-error *ngIf="hasErrorAddress('state', 'required')"
                    >O estado é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <button mat-flat-button matStepperPrevious class="gray me-15">
              Voltar
            </button>
            <button
              mat-flat-button
              matStepperNext
              class="tagus"
              [disabled]="!addressForm.valid"
            >
              Próximo
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="bankForm">
        <ng-template matStepLabel>Dados Bancários</ng-template>
        <form [formGroup]="bankForm">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Banco <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-bank-line"></i>
                  <mat-label>Nome do banco</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="name"
                    id="name"
                    style="text-transform: uppercase;"
                  />
                  <mat-error *ngIf="hasErrorBank('name', 'required')"
                    >O nome do banco é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Agência <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-bank-card-line"></i>
                  <mat-label>Insira o nº da agência</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="agency"
                    id="agency"
                    mask="separator"
                  />
                  <mat-error *ngIf="hasErrorBank('agency', 'required')"
                    >A agência é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Conta <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-account-box-line"></i>
                  <mat-label>Nº da conta</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="account"
                    id="account"
                    (input)="formatAccountNumber($event)"
                  />
                  <mat-error *ngIf="hasErrorBank('account', 'required')"
                    >O número da conta é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Tipo de Pessoa <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-user-line"></i>
                  <mat-label>Selecione o tipo</mat-label>
                  <mat-select formControlName="accountType" id="accountType">
                    <mat-option value="">Selecione uma opção</mat-option>
                    <mat-option value="PF">Pessoa Física (PF)</mat-option>
                    <mat-option value="PJ">Pessoa Jurídica (PJ)</mat-option>
                  </mat-select>
                  <mat-error *ngIf="hasErrorBank('accountType', 'required')"
                    >O tipo de pessoa é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Tipo da Conta <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-list-check-2"></i>
                  <mat-label>Insira o tipo da conta</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="typeAccount"
                    id="typeAccount"
                  />
                  <mat-error *ngIf="hasErrorBank('typeAccount', 'required')"
                    >O tipo da conta é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Chave PIX <span>*</span></label
                >
                <mat-form-field appearance="fill">
                  <i class="ri-shield-keyhole-line"></i>
                  <mat-label>Insira a chave PIX</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="keyPix"
                    id="keyPix"
                  />
                  <mat-error *ngIf="hasErrorBank('keyPix', 'required')"
                    >A chave pix é obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <button mat-flat-button matStepperPrevious class="gray me-15">
              Voltar
            </button>
            <button
              mat-flat-button
              (click)="onSubmit()"
              class="tagus"
              [disabled]="!bankForm.valid"
            >
              Continuar e Cadastrar
            </button>
          </div>
          <div *ngIf="isRegisterLoading">
            <mat-card appearance="outlined">
              <mat-card-content
                >Aguarde... estamos registrando o professional em nossa base de
                dados</mat-card-content
              >
            </mat-card>
          </div>
        </form>
      </mat-step>
    </mat-stepper>
  </mat-card-content>
</mat-card>
